import defaultOrdersQueueConfig from './default';

let config;

try {
  const loadedConfig = require('./' + process.env.REACT_APP_PROJECT_NAME + '-ordersqueue-config');
  config = loadedConfig?.default ?? loadedConfig;
} catch (e) {
  if (defaultOrdersQueueConfig && typeof defaultOrdersQueueConfig === 'object') {
    config = defaultOrdersQueueConfig;
  } else {
    config = {};
  }
}

export default config;
